module.exports = __webpack_public_path__ + "front/img/yqh05.7bd2b0e1.png";